const RESULTS_VIEW_TYPES = {
  AUTO: "auto",
  LIST: "list",
  AGGREGATE: "aggregate",
} as const

export default RESULTS_VIEW_TYPES
